import { Element } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-light-svg-icons';
import { SalvLabel, SalvAccordion, SalvButton, Size } from '@salvapp/ui-components';
import React, { useContext, useState } from 'react';
import { ApiSanctionHit, type ApiScreeningHitAiInsight } from '../../../api';
import { ScreeningMatchesContext } from './Matches';
import { FeedbackRating, saveAiInsightClickEvent } from '../../../tracking/userEventTracker';
import ScreeningAiInsightFeedbackModal from './ScreeningAiInsightFeedbackModal';
import { faComments } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  index: number;
  isFirst: boolean;
  hit: ApiSanctionHit;
  aiInsight: ApiScreeningHitAiInsight;
  giveFeedbackForAiInsight: (rating: FeedbackRating, explanation: string) => Promise<void>;
}

const ScreeningAiInsight = ({ index, isFirst, hit, aiInsight, giveFeedbackForAiInsight }: Props) => {
  const [isExpandedInternal, setExpandedInternal] = useState(false);
  const { isFirstMatchAiInsightExpanded, toggleFirstMatchAiInsightExpansion } = useContext(ScreeningMatchesContext);

  const isExpanded = isFirst ? isFirstMatchAiInsightExpanded : isExpandedInternal;
  const toggleExpansion = isFirst ? toggleFirstMatchAiInsightExpansion : () => setExpandedInternal((prev) => !prev);

  const [isModalVisible, setModalVisibility] = useState(false);

  const labelVariant = (() => {
    switch (aiInsight.areNamesEqual) {
      case true:
        return 'danger';
      case false:
        return 'success';
    }
  })();

  const labelText = (() => {
    switch (aiInsight.areNamesEqual) {
      case true:
        return 'Can be a True Positive - input and match are equivalent';
      case false:
        return 'Likely a False Positive - input and match are NOT equivalent';
    }
  })();

  const Title = () => (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <span>Salv AI Insight</span>
      <FontAwesomeIcon icon={faSparkles} />
      <SalvLabel variant={labelVariant}>{labelText}</SalvLabel>
    </div>
  );

  return (
    <tr className={`custom-table-row-${index % 2} salv-ai-insight`}>
      <td colSpan={4}>
        <SalvAccordion
          isExpanded={isExpanded}
          onToggle={async () => {
            toggleExpansion();
            await saveAiInsightClickEvent();
          }}
          size={Size.SMALL}
          ariaLabel={'Salv AI Insight for Match ' + hit.record?.externalId}
          label={<Title />}
        >
          <Element name={isFirst ? 'salv-first-match' : ''}>
            <div style={{ flex: '1 1 0' }}>{aiInsight.context}</div>
            <div className={'m-t-8'} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <SalvButton
                label={'Feedback'}
                size={Size.EXTRA_SMALL}
                variant={'muted'}
                onClick={() => setModalVisibility(true)}
                icon={faComments}
              />
            </div>
            <ScreeningAiInsightFeedbackModal
              show={isModalVisible}
              onHide={() => setModalVisibility(false)}
              giveFeedbackForAiInsight={giveFeedbackForAiInsight}
            />
          </Element>
        </SalvAccordion>
      </td>
    </tr>
  );
};

export default ScreeningAiInsight;
